import { createReducer } from 'typesafe-actions'
import { PurchaseMode, setPurchaseModeState } from '../actions/app/purchaseMode.actions'

export const defaultState = 'purchase' as PurchaseMode

const purchaseModeReducer = createReducer(defaultState)
    .handleAction(setPurchaseModeState, (state, action) => action.payload)

export default purchaseModeReducer
